import { Box, Typography } from "@mui/material";
import noDataImage from "../assets/baseVersion/nodata_available.svg";
import { FRAMEWORK_NOT_ENABLED_MESSAGE } from "../shared/hooks/useFrameworks";

// Shown in place of a compliance framework's data when the framework is switched off
const FrameworkNotEnabled = ({ height = "60vh" }: { height?: number | string }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height,
      p: 4,
      textAlign: "center",
    }}
  >
    <Box
      component="img"
      src={noDataImage}
      alt=""
      sx={{ width: "90px", height: "auto", mb: 2, opacity: 0.8 }}
    />
    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "18px" }}>
      {FRAMEWORK_NOT_ENABLED_MESSAGE}
    </Typography>
  </Box>
);

export default FrameworkNotEnabled;
